import ZingTouch from "../../../../lib/ZingTouch/ZingTouch";
import { sendDataMessage } from '../../../../lib/utils';
const useKey = (dc, rootContainer) => {
    const region = new ZingTouch.Region(rootContainer);
    const init = (ele, type) => {
        const tapStart = () => {
            sendDataMessage({ type: 'down', key: type }, dc);
        };
        const tapEnd = () => {
            sendDataMessage({ type: 'up', key: type }, dc);
        };
        const keyTap = new ZingTouch.Tap({ maxDelay: 9999999999999999999999999, onStart: tapStart, onEnd: tapEnd });
        region.bind(ele, keyTap, () => { });
    };
    return { init };
};
export default useKey;
